import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { getFormattedTime } from 'webapp/utils/number';

import highlightResult from 'webapp/helpers/highlight-result';
import visibleCheckItem from 'webapp/modifiers/visible-check-item';
import BoardImagePreviewComponent from 'webapp/components/board/image-preview';
import type { Args } from 'webapp/components/boards/select/item-base';
import BoardsSelectItemBaseComponent from 'webapp/components/boards/select/item-base';
import DummyCellComponent from 'webapp/components/dummy-cell';
import FormCheckboxComponent from 'webapp/components/form/checkbox';
import TagContainerComponent from 'webapp/components/tag-container';
import ToolTipWithIconComponent from 'webapp/components/tool-tip-with-icon';
import UsedSourcesListComponent from 'webapp/components/used-sources-list';
import VerificationBadgeComponent from 'webapp/components/verification/badge';

import Report from 'webapp/models-custom/report';

export default class BoardsSelectTableRowComponent extends BoardsSelectItemBaseComponent<Args> {
	@service('current-user') declare currentUserService: Service.CurrentUser;
	@service('model-manager/sources') declare mmSourcesService: Service.ModelManager.Sources;

	dateTimeFormat = 'MMM D, YYYY h:mma';

	get createdDateTimeText(): string {
		return getFormattedTime(
			this.args.model.created,
			this.currentUserService.model?.timezone,
			this.dateTimeFormat,
		);
	}

	get modifiedText(): string {
		const model = this.args.model;

		let modifiedText = '';
		if (this.isModelBoardFromAnotherSpace(model)) {
			if (model.modified) {
				const formattedDateTime = getFormattedTime(
					model.modified,
					this.currentUserService.model?.timezone,
					this.dateTimeFormat,
				);
				modifiedText = `by ${model.modifiedByName} on ${formattedDateTime}`;
			}
		}

		return modifiedText;
	}

	get sourcesList() {
		const model = this.args.model;
		if (model instanceof Report) {
			return [];
		} else {
			return model.sourcesList;
		}
	}
	<template>
		{{#if this.isVisibleOnScreen}}
			<tr
				role="button"
				data-id={{@model.id}}
				class="item {{if this.isChecked 'checked'}}"
				{{on "click" (fn this.select @model)}}
			>
				<td class="c0 no-grow">
					<FormCheckboxComponent
						@selected={{this.isChecked}}
						@onBeforeChange={{this.beforeSelect}}
						@onChange={{fn @onSelect @model}}
					/>
				</td>
				<td class="c1 no-grow">
					<BoardImagePreviewComponent
						@image={{@model.image}}
						@color={{this.color}}
						@model={{@model}}
						@theme={{this.themeId}}
						@isLazyLoaded={{true}}
						@lazyLoadScrollContainer={{this.lazyLoadScrollContainerSelector}}
					/>
				</td>
				<td class="c2">
					<strong>
						{{#if this.boardFromAnotherSpaceSourceWarning}}
							<ToolTipWithIconComponent
								@text={{this.boardFromAnotherSpaceSourceWarning}}
								@iconName="AlertFill"
								@maxWidth={{300}}
							/>
						{{/if}}
						{{highlightResult text=this.name match=this.activeFilter}}
						<VerificationBadgeComponent
							@verification={{this.verificationInfo}}
							@entityLabel="databoard"
							@size="sm"
						/>
					</strong>
				</td>
				{{#if this.isBoardFromAnotherSpace}}
					<td>
						{{this.modelAsBoardFromAnotherSpace.accountName}}
					</td>
					<td class="c4 prio-medium" data-label="Last modified: ">
						{{this.modifiedText}}
					</td>
				{{/if}}
				{{#unless @hideDatasourceColumn}}
					<td class="c3 prio-low">
						<UsedSourcesListComponent @sources={{this.sourcesList}} />
					</td>
				{{/unless}}
				{{#unless this.isBoardFromAnotherSpace}}
					<td class="c4 prio-medium" data-label="Created: ">
						{{this.createdDateTimeText}}
					</td>
					{{!-- <td class="c5 prio-medium" data-label="Modified: ">
                {{this.modifiedDateTimeText}}
            </td> --}}
					<td class="c6 prio-medium">
						<TagContainerComponent
							@model={{this.modelAsBoardOrBoardLoop}}
							@canEdit={{false}}
						/>
					</td>
				{{/unless}}
			</tr>
		{{else}}
			<tr data-id={{@model.id}} class="item" {{visibleCheckItem this.visibleChanged false}}>
				<DummyCellComponent @colspan={{6}} />
			</tr>
		{{/if}}
	</template>
}
